// eslint-disable-next-line max-classes-per-file
import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray } from 'react-final-form-arrays';
import { FormSpy } from 'react-final-form';
import { trueFalseOptions } from '../../OnboardingConstants';
import GenericToggleButtonGroupField from '../../../commons/form-fields/GenericToggleButtonGroupField';
import HeaderAndError from '../../../commons/form-fields/HeaderAndError';
import GenericTextAreaInputField from '../../../commons/form-fields/GenericTextAreaInputField';
import GenericTextInputField from '../../../commons/form-fields/GenericTextInputField';
import { validateStartDateBeforeEndDate } from '../../../commons/utils';
import { ErrorMessage } from '../../../commons/form-fields/ErrorMessage';

class SingleBoardMemberFields extends React.Component {
    render() {
        const { name, index, fields } = this.props;

        const isCurrentBoardMember =
            // eslint-disable-next-line unicorn/consistent-destructuring
            this.props.fields.value[index]?.isCurrentBoardMember;
        return (
            <div className="w-auto mx-auto bg-gray-100 border-gray-200 focus:border-gray-700 border-2 px-2 md:px-6 py-1 md:mt-3 md:mb-6 rounded text-sm">
                <GenericTextInputField
                    name={`${name}[${index}].name`}
                    label={`${index + 1}. Company/Organization Name`}
                    type="text"
                    required
                />
                <GenericToggleButtonGroupField
                    name={`${name}[${index}].isCurrentBoardMember`}
                    inlineLabel={
                        'Are you currently a board member at this company?'
                    }
                    options={trueFalseOptions}
                />
                <GenericToggleButtonGroupField
                    name={`${name}[${index}].isPublicCompany`}
                    inlineLabel={
                        'Does this company have publicly traded securities?'
                    }
                    options={trueFalseOptions}
                />
                <div className="md:grid md:grid-cols-3 md:gap-6">
                    <div className="col-span-3 sm:col-span-1">
                        <GenericTextInputField
                            name={`${name}[${index}].title`}
                            label={'Title'}
                            type={'text'}
                            required
                        />
                    </div>
                    <div className="col-span-3 sm:col-span-1">
                        <GenericTextInputField
                            name={`${name}[${index}].startDate`}
                            label={'Start Date'}
                            type="date"
                            validateAndRequiredDate
                        />
                    </div>
                    <div className="col-span-3 sm:col-span-1">
                        {!isCurrentBoardMember && (
                            <GenericTextInputField
                                name={`${name}[${index}].endDate`}
                                label={'End Date'}
                                type="date"
                                validateAndRequiredDate
                            />
                        )}
                    </div>
                </div>

                <GenericTextInputField
                    name={`${name}[${index}].location`}
                    label={'Location'}
                    type="text"
                    placeholder="Seattle, Washington, USA"
                />

                <GenericTextAreaInputField
                    name={`${name}[${index}].description`}
                    label={'Brief Company/Organization Description'}
                />

                <div>
                    <button
                        className="text-teal-600 hover:text-teal-700 underline font-bold py-1 px-3 rounded place-content-end mb-2 md:mb-4"
                        type="button"
                        onClick={() => {
                            if (fields.value.length === 1) {
                                fields.update(0, null);
                            } else {
                                fields.remove(index);
                            }
                        }}
                        data-testid={`info.resume.boardMemberships[${index}].removeBoardMembership`}
                    >
                        {' '}
                        Remove Board Membership
                    </button>
                </div>
            </div>
        );
    }
}

SingleBoardMemberFields.propTypes = {
    name: PropTypes.string,
    index: PropTypes.number,
    fields: PropTypes.array,
    values: PropTypes.any,
};

export class BoardMembershipInner extends React.Component {
    // eslint-disable-next-line no-unused-vars
    getSnapshotBeforeUpdate(prevProps, prevState) {
        const prevValue = prevProps.values.info?.resume?.isBoardMember;
        const currValue = this.props.values.info?.resume?.isBoardMember;
        if (prevValue !== currValue) {
            if (currValue) {
                const organisations = [{}];
                this.props.form.change(
                    'info.resume.boardMemberships',
                    organisations
                );
            } else {
                const organisations = [];
                this.props.form.change(
                    'info.resume.boardMemberships',
                    organisations
                );
            }
        }
        return null;
    }

    render() {
        const isBoardMember = this.props.values.info?.resume?.isBoardMember;
        return (
            <FieldArray
                name={'info.resume.boardMemberships'}
                validate={validateStartDateBeforeEndDate}
                render={({ fields, meta }) => (
                    <div>
                        {isBoardMember && (
                            <div data-testid="board-membership-information">
                                <HeaderAndError
                                    label="Board Membership Information"
                                    style="block text-teal-700 font-bold pl-1"
                                />
                                {(fields.value ?? []).map((field, index) => (
                                    <SingleBoardMemberFields
                                        key={index.toString()}
                                        name={fields.name}
                                        index={index}
                                        fields={fields}
                                    />
                                ))}
                                <button
                                    className="text-teal-600 hover:text-teal-700 underline font-bold mt-2 md:mt-0 py-1 px-4 rounded mb-4"
                                    type="button"
                                    onClick={() => fields.push({})}
                                    data-testid="add-board-membership"
                                >
                                    + Add Another Board Membership
                                </button>

                                {typeof meta.error === 'string' && (
                                    <ErrorMessage meta={meta} />
                                )}
                            </div>
                        )}
                    </div>
                )}
            />
        );
    }
}

BoardMembershipInner.propTypes = {
    values: PropTypes.any,
    form: PropTypes.any,
};

const BoardMembershipOrganisationSection = (props) => (
    <FormSpy {...props} component={BoardMembershipInner} />
);
export { BoardMembershipOrganisationSection };
